import { gql } from '@apollo/client';
import { workPackageFragments } from '../work-packages';

export const blockFragments = {
  blockCommentItem: gql`
    fragment BlockCommentItem on BlockComment {
      id
      comment
      createdAt
      createdBy {
        id
        firstName
        lastName
        persona
      }
    }
  `,
};

export const GET_USER_BLOCKS = gql`
  query blocks($input: BlockFilterInput, $paging: PagingInput) {
    blocks(paging: $paging, input: $input) {
      total
      cursor
      items {
        id
        currentStatusI18n
        type {
          id
          title
          description
        }
        comments {
          ...BlockCommentItem
        }
        creator {
          id
          firstName
          lastName
          imageUrl
          persona
        }
        attachment {
          id
          url
        }
        impactedCommodities {
          materialCommodity {
            id
          }
          weld {
            id
          }
        }
        impactedMilestones {
          id
          name
          hours
          quantity {
            ...Quantity
          }
        }
        workPackage {
          id
          tag
          primaryOwners {
            persona
            crewMember {
              id
            }
          }
          secondaryOwners {
            persona
            crewMember {
              id
            }
          }
          otherOwners {
            persona
            crewMember {
              id
            }
          }
        }
      }
    }
    ${workPackageFragments.quantity}
    ${blockFragments.blockCommentItem}
  }
`;

export const GET_BLOCK_BY_ID = gql`
  query getBlockById($id: ID!) {
    blockById(id: $id) {
      id
      type {
        id
        title
        description
      }
      comments {
        ...BlockCommentItem
      }
      creator {
        id
        firstName
        lastName
        imageUrl
      }
      attachment {
        id
        url
      }
      impactedCommodities {
        materialCommodity {
          id
          tag
        }
        weld {
          id
          tag
        }
      }
      impactedMilestones {
        id
        name
      }
      currentStatusI18n
    }
    ${blockFragments.blockCommentItem}
  }
`;

export const CREATE_BLOCK = gql`
  mutation createBlock($input: CreateBlockInput!) {
    createBlock(input: $input) {
      block {
        id
        type {
          id
          title
          description
        }
        comments {
          id
          comment
        }
        currentStatusI18n
        statusHistory {
          id
          codeI18n
          createdAt
        }
        impactedCommodities {
          weld {
            id
            status {
              id
              status
            }
          }
        }
        impactedMilestones {
          id
          blocks {
            id
            currentStatusI18n
            type {
              id
            }
          }
        }
        workPackage {
          id
          numBlocks
        }
      }
      error {
        errorCode
        milestone {
          id
          name
          commodity {
            materialCommodity {
              id
              tag
              type {
                id
                name
              }
            }
            weld {
              id
              tag
              type {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;
export const RESOLVE_BLOCK = gql`
  mutation resolveBlock($input: ResolveBlockInput!) {
    resolveBlock(input: $input) {
      block {
        id
        type {
          id
          title
          description
        }
        comments {
          ...BlockCommentItem
        }
        creator {
          id
          firstName
          lastName
          imageUrl
        }
        attachment {
          id
          url
        }
        impactedCommodities {
          materialCommodity {
            id
            tag
          }
          weld {
            id
            tag
            status {
              id
              status
            }
          }
        }
        currentStatusI18n
        impactedMilestones {
          id
          blocks {
            id
            currentStatusI18n
            type {
              id
            }
          }
          currentStatus {
            id
            codeI18n
            rejectionType {
              id
              reason
            }
            comments
            createdAt
            createdBy {
              id
              firstName
              lastName
            }
          }
        }
        workPackage {
          id
          numBlocks
        }
      }
      error
    }
    ${blockFragments.blockCommentItem}
  }
`;

export const ADD_BLOCK_COMMENT = gql`
  mutation addBlockComment($input: AddBlockCommentInput!) {
    addBlockComment(input: $input) {
      block {
        id
        type {
          id
          title
          description
        }
        currentStatusI18n
        comments {
          ...BlockCommentItem
        }
      }
      error
    }
    ${blockFragments.blockCommentItem}
  }
`;

export const ADD_BLOCK_ATTACHMENT = gql`
  mutation addBlockAttachment($input: AddBlockAttachmentInput!) {
    addBlockAttachment(input: $input) {
      block {
        id
        attachment {
          id
          url
        }
      }
      error
    }
  }
`;

export const DELETE_BLOCK_ATTACHMENT = gql`
  mutation deleteBlockAttachment($input: DeleteBlockAttachmentInput!) {
    deleteBlockAttachment(input: $input) {
      block {
        id
        attachment {
          id
        }
      }
      error
    }
  }
`;

export const GET_BLOCK_TYPES = gql`
  query AvailableBlockTypes {
    blockTypes: availableBlockTypes {
      id
      title
      description
    }
  }
`;

export const SUBSCRIPTION_BLOCK_CREATED = gql`
  subscription onBlockCreated {
    blockCreated {
      blockId
      commodityIds
      workPackageId
      affectedOwnerIds
      projectId
    }
  }
`;

export const SUBSCRIPTION_BLOCK_UPDATED = gql`
  subscription onBlockUpdated {
    blockUpdated {
      blockId
      commodityIds
      workPackageId
      affectedOwnerIds
      projectId
    }
  }
`;
